import instance from '../axios.config';
import { handleError } from '../../utils';

const setAdminWalletMinimumAmount = async (body) => {
  try {
    const { data } = await instance.patch('/admin/wallet/min-balance', body);

    return data;
  } catch (error) {
    handleError(error);
  }
};

export { setAdminWalletMinimumAmount };
